import { Component, computed, Input } from '@angular/core';
import { UserMessage } from '@sendbird/chat/message';
import { SendbirdChatService } from '../../sendbird-chat.service';

@Component({
  standalone: true,
  selector: 'app-reaction-button',
  templateUrl: './reaction-button.component.html',
  styleUrls: ['./reaction-button.component.scss'],
})
export class ReactionButtonComponent {
  likeCount = 0;
  readonly channel = this.sendbirdChatService.selectedChannel;

  isSelfUserReaction = computed(() => {
    return this.message.reactions?.find(r => r.key === 'like')?.hasCurrentUserReacted || false;
  });
  @Input() message!: UserMessage;
  @Input() currentUserId!: string;

  calcLikeCount() {
    return this.message.reactions?.find(r => r.key === 'like')?.userIds.length || 0;
  }

  constructor(private sendbirdChatService: SendbirdChatService) {}

  ngOnChanges() {
    if (this.message) {
      this.likeCount = this.calcLikeCount();
    }
  }

  async toggleLike() {
    if (this.sendbirdChatService.checkNeedToLogin()) {
      return;
    }
    // const alreadyLiked =
    //   this.message.reactions?.find(r => r.key === 'like')?.userIds.includes(this.currentUserId) || false;

    const alreadyLiked = this.message.reactions
      ?.find(r => r.key === 'like')
      ?.userIds.find(id => this.sendbirdChatService.checkSelfUser(id));
    if (!this.channel) {
      return;
    }

    try {
      const reactionEvent = alreadyLiked?.length
        ? await this.sendbirdChatService.removeLike(this.message)
        : await this.sendbirdChatService.addLike(this.message);

      if (reactionEvent) {
        this.message.applyReactionEvent(reactionEvent);
        this.likeCount = this.calcLikeCount();
        // 重置閒置計時器
        this.sendbirdChatService.resetIdleTimer();
      }
    } catch (err) {
      console.error('Failed to toggle reaction:', err);
    }
  }
}
